var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c("label", { staticClass: "label" }, [
          _vm._v("Please select a quote"),
        ]),
        _c(
          "bulma-table",
          {
            staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
            attrs: {
              columns: _vm.columns,
              "page-index": _vm.filter.pageIndex,
              "page-size": _vm.filter.pageSize,
              "total-rows": _vm.totalRows,
              "sort-column": _vm.filter.sortColumn,
              "sort-order": _vm.filter.sortOrder,
              "show-pagination": false,
            },
            on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
          },
          [
            _vm._l(_vm.quotes, function (entity, index) {
              return _c(
                "tr",
                {
                  key: entity.quoteNo,
                  class: { "is-selected": _vm.selectedRow === index },
                  on: {
                    click: function ($event) {
                      return _vm.highlightSelected(index, $event)
                    },
                  },
                },
                [
                  _c("td", [_vm._v(" " + _vm._s(entity.quoteNoRef) + " ")]),
                  _c("td", [_vm._v(" " + _vm._s(entity.regoNo) + " ")]),
                  _c("td", [
                    _vm._v(
                      " " + _vm._s(entity.make + " " + entity.model) + " "
                    ),
                  ]),
                  _c("td", [_vm._v(" " + _vm._s(entity.claimNo) + " ")]),
                  _c("td", { staticClass: "is-selected" }, [
                    _vm._v(" " + _vm._s(entity.fullName) + " "),
                  ]),
                  _c("td", [_vm._v(" " + _vm._s(entity.jobStageText) + " ")]),
                ]
              )
            }),
            _c("template", { slot: "empty" }, [
              _c("section", { staticClass: "section" }, [
                _c(
                  "div",
                  { staticClass: "content has-text-grey has-text-centered" },
                  [
                    _c("span", { attrs: { icon: "icon is-large" } }, [
                      _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
                    ]),
                    _c("p", [_vm._v("Nothing")]),
                  ]
                ),
              ]),
            ]),
          ],
          2
        ),
      ],
      1
    ),
    _vm.invalidQuoteId
      ? _c("span", { staticClass: "has-text-danger" }, [
          _vm._m(0),
          _vm._v(" Please select a quote before continuing. "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-danger" }, [
      _c("i", { staticClass: "mdi mdi-alert-octagram mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }